import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	group: string | null;
	severity: string | null;
	fromDate: number | null;
	toDate: number | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: false,
	sortFieldName: null,
	group: null,
	severity: null,
	fromDate: null,
	toDate: null,
};

const activeAlarms = createSlice({
	name: 'activeAlarms',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setGroup: (state, action: PayloadAction<{ group: string | null }>) => {
			state.group = action.payload.group;
			state.page = initialState.page;
		},
		setSeverity: (state, action: PayloadAction<{ severity: string | null }>) => {
			state.severity = action.payload.severity;
			state.page = initialState.page;
		},
		setFromDate: (
			state,
			action: PayloadAction<{ fromDate: number | null }>,
		) => {
			if (action.payload.fromDate) {
				state.fromDate = startOfDayInMilliseconds(action.payload.fromDate);
			} else {
				state.fromDate = null;
			}

			state.page = initialState.page;
		},
		setToDate: (
			state,
			action: PayloadAction<{ toDate: number | null }>,
		) => {
			if (action.payload.toDate) {
				state.toDate = startOfDayInMilliseconds(action.payload.toDate);
			} else {
				state.toDate = null;
			}

			state.page = initialState.page;
		},
		resetAlarmHistoryTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setGroup,
	setSeverity,
	setFromDate,
	setToDate,
} = activeAlarms.actions;

export default activeAlarms.reducer;
